import React from 'react';
import PropTypes from 'prop-types';
import useAuth from './useAuth';
import Loader from '../components/Loader';
import { RouteNames } from '../constants/Routes';

const SIGNIN_RETURN_PATH_KEY = 'signin:returnPath';

function getCurrentPath() {
	const { pathname = '', search = '', hash = '' } = window.location;
	return `${pathname}${search}${hash}`;
}

function AuthGuard({ children }) {
	const { signinRedirect, isAuthenticated } = useAuth();

	if (!isAuthenticated) {
		const currentPath = getCurrentPath();
		let returnPath;
		if (
			currentPath &&
			currentPath !== RouteNames.SIGNIN &&
			currentPath !== RouteNames.SIGNOUT &&
			!currentPath.endsWith(RouteNames.SILENT_RENEW)
		) {
			returnPath = currentPath;
			sessionStorage.setItem(SIGNIN_RETURN_PATH_KEY, currentPath);
		}

		signinRedirect(returnPath);
		return <Loader />;
	}

	return children;
}

AuthGuard.propTypes = {
	children: PropTypes.node,
};

export default AuthGuard;
